import { createArray } from 'tools/array'
import { isEmpty } from 'tools/string'
import { formatDayRange, reactDayPickerDaysOfWeek } from 'tools/date'
import { isObjectEmpty } from 'tools/object'

export const parseAvailableTime = (availableTime, splitBy) => {
  const fromDate = new Date()
  const toDate = new Date()

  if (isEmpty(availableTime)) {
    return { fromDate, toDate }
  }

  const [from, to] = (availableTime || '').split(splitBy)
  const fromParts = from.match(/(\d+):(\d+) (\w+)/)
  const fromHours = (+fromParts[1] % 12) + (/pm/i.test(fromParts[3]) ? 12 : 0)
  const fromMinutes = +fromParts[2]

  const toParts = to.match(/(\d+):(\d+) (\w+)/)
  const toHours = (+toParts[1] % 12) + (/pm/i.test(toParts[3]) ? 12 : 0)
  const toMinutes = +toParts[2]

  fromDate.setHours(fromHours, fromMinutes, 0, 0)
  toDate.setHours(toHours, toMinutes, 0, 0)

  return { fromDate, toDate }
}

// Format store hours for display purpose
// - Group same day of weeks/date range together
// - Filter out past date range
export const formatStoreHours = (t, hours) => {
  const group = {
    pickup: {
      normals: {},
      blockoffs: {},
      specials: {}
    },
    delivery: {
      normals: {},
      blockoffs: {},
      specials: {}
    }
  }
  const now = new Date()

  if (!isObjectEmpty(hours)) {
    hours.forEach((hour) => {
      const type = hour.isPickup ? 'pickup' : 'delivery'
      if (!hour.isSpecial) {
        // Group normal day by formatted days of week
        const key = formatDayRange(hour.availableDays, 'short', t)
        group[type].normals[key] = group[type].normals[key]
          ? group[type].normals[key].concat(hour)
          : [hour]
      } else {
        // Filter out special hours in the past
        const [ from, to ] = hour.dateRange.split(' - ')
        const fromDate = new Date(from)
        const toDate = new Date(to)
        const isNotPast = to ? toDate > now : fromDate > now
        if (isNotPast) {
          if (hour.quota === 0) {
            // No need to group blockoffs date
            group[type].blockoffs[hour.dateRange] = hour
          } else {
            // Group special hours by date range
            const key = hour.dateRange
            group[type].specials[key] = group[type].specials[key]
              ? group[type].specials[key].concat(hour)
              : [hour]
          }
        }
      }
    })
  }

  // Sort time options from the earliest time ascendingly
  const sortedGroup = Object.keys(group).reduce((newGroup, groupKey) => {
    newGroup[groupKey] = Object.keys(group[groupKey]).reduce((newObj, key) => {
      newObj[key] = Object.keys(group[groupKey][key]).reduce((o, k) => {
        o[k] = Array.isArray(group[groupKey][key][k]) ? group[groupKey][key][k].sort((a, b) => {
          const { fromDate: fromA } = parseAvailableTime(a.availableTimes, ' - ')
          const { fromDate: fromB } = parseAvailableTime(b.availableTimes, ' - ')
          return fromA.getHours() > fromB.getHours() ? 1 : -1
        }) : group[groupKey][key][k]
        return o
      }, {})
      return newObj
    }, {})
    return newGroup
  }, {})

  return sortedGroup
}

export const getDisabledDaysOfWeek = (storeHours) => ({
  daysOfWeek: storeHours
    .filter(hour => !hour.isSpecial)
    .reduce((days, hour) =>
      days.filter(day => !hour.availableDays.split(',').map(day => reactDayPickerDaysOfWeek.indexOf(day.trim())).includes(day)),
    createArray(7))
})

export const getBlockOffDates = (storeHours) => storeHours
  .filter(hour => hour.isSpecial && hour.quota === 0)
  .map(hour => {
    const [ from, to ] = hour.dateRange.split(' - ')
    return { from: new Date(from), to: new Date(to) }
  })
